import { inject, Injectable, OnDestroy } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { TranslocoService } from '@jsverse/transloco';
import { Subject, switchMap, takeUntil } from 'rxjs';

@Injectable()
export class MatDatepickerLocalized extends MatDatepickerIntl implements OnDestroy {
    private readonly translocoService = inject(TranslocoService);
    private readonly dateAdapter = inject(DateAdapter);
    private readonly loaded: Subject<void> = new Subject<void>();

    constructor() {
        super();
        this.translocoService.langChanges$
            .pipe(
                switchMap((language) => {
                    this.dateAdapter.setLocale(language);
                    return this.translocoService.load(language);
                }),
                takeUntil(this.loaded)
            )
            .subscribe({ 
                next: () => this.setLabels(),
                error: (message) => console.error('Error loading translations for MatDatepickerIntl:', message)
            });
    }

    ngOnDestroy(): void {
        this.loaded.next();
        this.loaded.complete();
        this.changes.complete();
    }

    private setLabels(): void {
        this.calendarLabel = this.translocoService.translate('shared.datepickers.calendarLabel');
        this.openCalendarLabel = this.translocoService.translate('shared.datepickers.openCalendarLabel');
        this.prevMonthLabel = this.translocoService.translate('shared.datepickers.prevMonthLabel');
        this.nextMonthLabel = this.translocoService.translate('shared.datepickers.nextMonthLabel');
        this.prevYearLabel = this.translocoService.translate('shared.datepickers.prevYearLabel');
        this.nextYearLabel = this.translocoService.translate('shared.datepickers.nextYearLabel');
        this.prevMultiYearLabel = this.translocoService.translate('shared.datepickers.prevMultiYearLabel');
        this.nextMultiYearLabel = this.translocoService.translate('shared.datepickers.nextMultiYearLabel');
        this.switchToMonthViewLabel = this.translocoService.translate('shared.datepickers.switchToMonthViewLabel');
        this.switchToMultiYearViewLabel = this.translocoService.translate('shared.datepickers.switchToMultiYearViewLabel');
        this.changes.next();
    }
}
